__turbopack_context__.v({
  "author": "bs-Bga_author",
  "authorInfo": "bs-Bga_authorInfo",
  "avatarWrapper": "bs-Bga_avatarWrapper",
  "card": "bs-Bga_card",
  "content": "bs-Bga_content",
  "imageWrapper": "bs-Bga_imageWrapper",
  "subtitle": "bs-Bga_subtitle",
});
